var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"pa-6"},[(_vm.logueado)?_c('Header'):_vm._e(),_c('Sidebar'),_c('v-main',{staticClass:"content"},[_c('div',[_c('transition',{attrs:{"appear":"","name":"fade"}},[_c('router-view')],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }